import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PromptIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon">
        <path
          id="Vector 424"
          d="M3.5 6.38281V4.88281C3.5 4.33053 3.94772 3.88281 4.5 3.88281H8M12.5 6.38281V4.88281C12.5 4.33053 12.0523 3.88281 11.5 3.88281H8M8 3.88281V12.8828M8 12.8828H5M8 12.8828H11"
          stroke={fillColor || '#383838'}
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export { PromptIcon };
